const ResultFields = {
  title: {},
  category: {
    snippet: {
      fallback: true
    }
  },

  otherTitleInformation: {},
  publications: {},
  natureOfContents: {},
  collections: {},
  contributions: {},
  abstract: {},
  subjects: {},
  handles: {},
  describedBy: {},
  _id: {},
  uri: {},
  id: {},
  documentId: {},
  temporalCoverages: {},
  collectionModes: {},
  timeDimensions: {},
  sampling: {},
  universe: {},
  geographicCoverages: {},
  dprexConcepts: {},
  dprexGroups: {},
  dprexTypes: {},
  searchappPublisher: {},
  calculatedTemporalCoverage: {},
  projectNotes: {},
  rights:{}
}
export default ResultFields
